import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'expanse-panel',
    templateUrl: './expanse-panel.component.html',
    styleUrls: ['./expanse-panel.component.scss'],
    animations: [
        trigger('animationShowHide', [
            state('close', style({ height: '0px', overflow: 'hidden' })),
            state('open', style({ height: '*', overflow: 'hidden' })),
            transition('open <=> close', animate('400ms ease-in-out')),
        ]),
        trigger('animationRotate', [
            state('close', style({ transform: 'rotate(0)' })),
            state('open', style({ transform: 'rotate(90deg)' })),
            transition('open <=> close', animate('400ms ease-in-out')),
        ]),
    ],
    standalone: false
})
export class ExpansePanelComponent implements OnInit, OnChanges {

  constructor() { }
  
  
  ngOnChanges(changes: SimpleChanges): void {
    if ( changes.open != null ){
      if ( changes.open.currentValue  == true) {
        this.sStatus = 'open';
      }else{
        this.sStatus = 'close';
      }
    }
  }

  @Input() open;
  sStatus = 'close';
  @Input()startOpen = false;
  @Input()title='sem titulo';
  onSwitch(){
    this.sStatus = this.sStatus === 'close' ? 'open' : 'close';
  }

  

  ngOnInit(): void {
      if ( this.startOpen ){
        this.onSwitch();
      }
  }

}
